import { css } from '@emotion/react';
import React from 'react';
import { borderRadius, Breakpoint, colorPalette, spacing } from '../../config/styles';

export enum ButtonSizeVariant {
  small = 'small',
  medium = 'medium',
}

const styles = {
  wrapper: (size: ButtonSizeVariant) => css`
    background-color: ${colorPalette.lightGreen};
    border-radius: ${borderRadius.circle};
    outline: 0;
    border: 0;
    padding: ${spacing['5']};
    display: flex;
    justify-content: center;
    align-items: center;
    ${size === ButtonSizeVariant.small &&
    css`
      svg {
        width: 25px;
        height: 25px;
      }
    `}

    ${size === ButtonSizeVariant.medium &&
    css`
      svg {
        width: 45px;
        height: 45px;

        ${Breakpoint.mobile} {
          width: 35px;
          height: 35px;
        }
      }
    `}
    
    &:hover {
      background-color: ${colorPalette.lightGreen70};
    }
  `,
};

const IconButton = ({
  onClick,
  children,
  size = ButtonSizeVariant.medium,
}: {
  onClick: () => void;
  children: React.ReactNode;
  size?: ButtonSizeVariant;
}) => {
  return (
    <button css={styles.wrapper(size)} onClick={onClick}>
      {children}
    </button>
  );
};

export default IconButton;
